import type * as React from 'react';

import type { Xinglet } from '@xing-com/crate-xinglet';

import { App } from './app';

export default class VideoPlayerXinglet implements Xinglet {
  public getComponent(): React.VFC {
    return (): JSX.Element => <App />;
  }
}
